import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useAuth } from "./AuthContext";

export function CommitteeList() {
    const [committees, setCommittees] = useState([]);
    const [people, setPeople] = useState([]);
    const [expandedIds, setExpandedIds] = useState({}); // track expanded users
    const { authToken } = useAuth();

    useEffect(() => {
        const loadData = async () => {
            try {
                const token = localStorage.getItem("auth_token") || authToken;
                const headers = token ? { Authorization: `Bearer ${token}` } : {};
                
                const [committeesRes, peopleRes] = await Promise.all([
                    axios.get("/api/committees", { headers }),
                    axios.get("/api/directory", { headers }),
                ]);

                setCommittees(committeesRes.data);
                setPeople(peopleRes.data);
            } catch (err) {
                toast.error("Error loading committees or directory");
            }
        };

        loadData();
    }, [authToken]);

    const personMap = {};
    people.forEach((p) => {
        personMap[p._id] = p;
    });

    const toggleExpand = (userId) => {
        setExpandedIds((prev) => ({
            ...prev,
            [userId]: !prev[userId],
        }));
    };

    return (
        <div className="container py-4">
            <div className="mx-auto" style={{ maxWidth: "750px" }}>
                {committees.length === 0 ? (
                    <p className="text-muted">No committees found.</p>
                ) : (
                    committees.map((committee) => {
                        const groupedByRole = {};

                        (committee.members || []).forEach((member) => {
                            const person = personMap[member.userId];
                            const name = person
                                ? `${person.first_name} ${person.surname}${person.known_as ? ` (${person.known_as})` : ""}`
                                : "Unknown Member";

                            const role = member.role?.trim() || "Member";

                            if (!groupedByRole[role]) {
                                groupedByRole[role] = [];
                            }

                            groupedByRole[role].push({ name, userId: member.userId });
                        });

                        return (
                            <div key={committee._id} className="mb-4">
                                <h5 className="border-bottom pb-1 text-center">{committee.name}</h5>

                                {Object.keys(groupedByRole).length === 0 ? (
                                    <p className="text-muted">No members assigned.</p>
                                ) : (
                                    Object.entries(groupedByRole)
                                        .sort(([a], [b]) => a.localeCompare(b))
                                        .map(([role, members], idx) => {
                                            const roleLabel = members.length > 1 ? `${role}s` : role;
                                            return (
                                                <div key={idx} className="mb-2">
                                                    <strong>{roleLabel}</strong>
                                                    <ul className="list-unstyled mb-0 ms-3">
                                                        {members
                                                            .sort((a, b) => a.name.localeCompare(b.name))
                                                            .map((member) => {
                                                                const isOpen = expandedIds[member.userId];
                                                                const person = personMap[member.userId];
                                                                return (
                                                                    <li key={member.userId} className="mb-1">
                                                                        <span
                                                                            style={{
                                                                                cursor: "pointer",
                                                                                userSelect: "none",
                                                                                fontFamily: "monospace",
                                                                            }}
                                                                            onClick={() => toggleExpand(member.userId)}
                                                                        >
                                                                            {isOpen ? "▾" : "▸"}
                                                                        </span>{" "}
                                                                        {member.name}

                                                                        {isOpen && person && (
                                                                            <ul className="list-unstyled ms-4 mt-1 small text-muted">
                                                                                {person.email_address && (
                                                                                    <li>
                                                                                        <strong>Email:</strong>{" "}
                                                                                        <a href={`mailto:${person.email_address}`}>
                                                                                            {person.email_address}
                                                                                        </a>
                                                                                    </li>
                                                                                )}
                                                                                {person.cell_number && (
                                                                                    <li>
                                                                                        <strong>Cell:</strong> {person.cell_number}{" "}
                                                                                        {person.preferred_number === "cell" && (
                                                                                            <span className="text-body-secondary">(Preferred)</span>
                                                                                        )}
                                                                                    </li>
                                                                                )}

                                                                                {person.home_number && (
                                                                                    <li>
                                                                                        <strong>Home:</strong> {person.home_number}{" "}
                                                                                        {person.preferred_number === "home" && (
                                                                                            <span className="text-body-secondary">(Preferred)</span>
                                                                                        )}
                                                                                    </li>
                                                                                )}
                                                                                {person.physical_address && (
                                                                                    <li>
                                                                                        <strong>Address:</strong> {person.physical_address}
                                                                                    </li>
                                                                                )}
                                                                            </ul>
                                                                        )}
                                                                    </li>
                                                                );
                                                            })}
                                                    </ul>
                                                </div>
                                            );
                                        })
                                )}
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
}
